// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202608261041/js/" + chunkId + "." + {"44":"8132c1c1","225":"7cf9634a","481":"84930679","486":"1549a836","770":"25a9b977"}[chunkId] + ".0.17193282954583933.chunk.js";
};